/* Keep Horizon's product and sticky prices in step with Easify's calculated surcharge.
   Only presentation changes here: Easify remains responsible for cart pricing. */
(function () {
  if (window.__pppPersonalisationPrice) return;
  window.__pppPersonalisationPrice = true;
  var timer;
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function moneyGBP(cents) { return new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(cents / 100); }
  function updateOrderSummary(form, app, base, surcharge) {
    var buttons = form && form.querySelector('.product-form-buttons');
    if (!buttons) return;
    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = Number(quantityInput && quantityInput.value || 1);
    if (!Number.isInteger(quantity) || quantity < 1) return;
    var panel = form.querySelector('[data-ppp-order-summary]');
    if (!panel) {
      panel = document.createElement('section');
      panel.className = 'ppp-order-summary';
      panel.setAttribute('data-ppp-order-summary', '');
      panel.setAttribute('aria-label', 'Your portrait total');
      panel.innerHTML = '<dl><div class="ppp-order-summary__row"><dt data-ppp-base-label>Portrait</dt><dd data-ppp-base></dd></div><div class="ppp-order-summary__row" data-ppp-extra-row><dt>Extra pets</dt><dd data-ppp-extra></dd></div><div class="ppp-order-summary__row ppp-order-summary__total"><dt data-ppp-total-label>Total</dt><dd data-ppp-total aria-live="polite" aria-atomic="true"></dd></div></dl><p class="ppp-order-summary__note">Free UK delivery (Express £4.99 if you need it sooner). Any discounts are shown at checkout.</p>';
      buttons.before(panel);
    }
    setText(panel.querySelector('[data-ppp-base-label]'), quantity > 1 ? 'Portraits × ' + quantity : 'Portrait');
    setText(panel.querySelector('[data-ppp-base]'), moneyGBP(base * quantity));
    setText(panel.querySelector('[data-ppp-extra]'), '+' + moneyGBP(surcharge * quantity));
    var extraRow = panel.querySelector('[data-ppp-extra-row]');
    if (extraRow.hidden !== !surcharge) extraRow.hidden = !surcharge;
    var total = moneyGBP((base + surcharge) * quantity);
    setText(panel.querySelector('[data-ppp-total]'), total);
    var button = buttons.querySelector('button[name="add"]');
    if (button) {
      var buttonPrice = button.querySelector('[data-ppp-cart-total]');
      if (!buttonPrice) {
        buttonPrice = document.createElement('span');
        buttonPrice.setAttribute('data-ppp-cart-total', '');
        button.appendChild(buttonPrice);
      }
      setText(buttonPrice, '· ' + total);
      if (buttonPrice.hidden !== button.disabled) buttonPrice.hidden = button.disabled;
    }
    if (!app.hasAttribute('data-ppp-order-summary-ready')) app.setAttribute('data-ppp-order-summary-ready', '');
  }
  function refresh() {
    document.querySelectorAll('[data-ppp-variant-prices]').forEach(function (data) {
      var scope = data.closest('.shopify-section');
      if (!scope) return;
      var config;
      try { config = JSON.parse(data.textContent); } catch (_) { return; }
      if (config.currency !== 'GBP') return;
      var form = scope.querySelector('product-form-component[data-product-id="' + config.productId + '"]');
      var selected = form && form.querySelector('input[name="id"]');
      var sticky = scope.querySelector('sticky-add-to-cart[data-product-id="' + config.productId + '"]');
      var id = selected && selected.value || sticky && sticky.dataset.currentVariantId;
      var base = config.prices[id];
      if (!Number.isFinite(base)) return;
      var app = scope.querySelector('.easify-product-options');
      if (!app) return;
      // A total-inclusive app summary must not be counted twice.
      var mode = window.TPOConfigs && window.TPOConfigs.settings && window.TPOConfigs.settings.totalPriceMode;
      if (mode !== 'exclude') return;
      var summary = app.querySelector('.po-priceSummary-price');
      var surcharge = summary ? Math.round(Number(summary.textContent.replace(/[^\d.-]/g, '')) * 100) : 0;
      if (!Number.isFinite(surcharge) || surcharge < 0) return;
      var money = moneyGBP(base + surcharge);
      updateOrderSummary(form, app, base, surcharge);
      var price = scope.querySelector('product-price[data-product-id="' + config.productId + '"]');
      [price, sticky].forEach(function (container) {
        if (!container) return;
        var orderTotal = form && form.querySelector('[data-ppp-total]');
        var displayMoney = container === sticky && orderTotal ? orderTotal.textContent : money;
        container.querySelectorAll('.price').forEach(function (el) {
          var text = el.querySelector('bdi') || el;
          if (text.textContent !== displayMoney) text.textContent = displayMoney;
        });
      });
      if (price) {
        var note = price.querySelector('[data-ppp-price-note]');
        if (!note) {
          note = document.createElement('small');
          note.setAttribute('data-ppp-price-note', '');
          note.setAttribute('aria-live', 'polite');
          note.style.display = 'block';
          price.appendChild(note);
        }
        var message = surcharge ? 'Includes your extra-pet options. Discounts and delivery are calculated at checkout.' : '';
        if (note.textContent !== message) note.textContent = message;
        note.hidden = !surcharge;
      }
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 60); }
  ['change', 'input', 'quantity-selector:update', 'variant:update', 'variant:selected', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('quantity-selector-component')) schedule();
  });
  function start() {
    refresh();
    var root = document.querySelector('main');
    if (root) new MutationObserver(schedule).observe(root, {subtree:true, childList:true, characterData:true,
      attributes:true, attributeFilter:['value','data-current-variant-id']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
